import React from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import CommissionInstallmentsDueFilterField from "./CommissionInstallmentsDueFilterField";
import {
  FILTER_CARD_CLASS,
  FILTER_LABEL_CLASS,
  FILTER_SEARCH_CLASS,
} from "./commissionsConstants";

const FILTER_BTN_RESET = {
  border: "none",
  outline: "none",
  WebkitAppearance: "none",
  appearance: "none",
};

function CommissionInstallmentsSearchFilters({
  dueFilter,
  onDueFilterChange,
  customStartDate,
  customEndDate,
  onCustomStartDateChange,
  onCustomEndDateChange,
  searchTerm,
  onSearchChange,
  onSearchClear,
  onClearAll,
  hasActiveFilters,
  resultCount,
  totalAwaiting,
  loading,
}) {
  return (
    <div
      className={`cms-installments-queue-filters ${FILTER_CARD_CLASS} !p-3 sm:!p-4`}
    >
      <div className="cms-installments-queue-filters__row flex w-full flex-row items-end gap-4">
        <div className="cms-installments-queue-filters__col min-w-0 flex-1 basis-0">
          <CommissionInstallmentsDueFilterField
            dueFilter={dueFilter}
            onDueFilterChange={onDueFilterChange}
            customStartDate={customStartDate}
            customEndDate={customEndDate}
            onCustomStartDateChange={onCustomStartDateChange}
            onCustomEndDateChange={onCustomEndDateChange}
          />
        </div>

        <div className="cms-installments-queue-filters__col flex min-w-0 flex-1 basis-0 flex-row items-end gap-2">
          <div className="relative min-w-0 flex-1">
            <label htmlFor="installments-search" className={FILTER_LABEL_CLASS}>
              Search
            </label>
            <FaSearch
              className="pointer-events-none absolute bottom-2.5 left-2.5 text-gray-400"
              size={13}
            />
            <input
              id="installments-search"
              type="text"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Name or client/user/app ID"
              className={`cms-installments-queue-filters__search ${FILTER_SEARCH_CLASS}`}
              autoComplete="off"
            />
            {searchTerm ? (
              <button
                type="button"
                onClick={onSearchClear}
                className="absolute bottom-2.5 right-2.5 text-gray-400 hover:text-gray-600"
                aria-label="Clear search"
                style={{
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  padding: 0,
                }}
              >
                <FaTimes size={11} />
              </button>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClearAll}
            disabled={!hasActiveFilters}
            className={`inline-flex h-9 shrink-0 items-center justify-center rounded-lg border px-4 text-[13px] font-medium shadow-sm transition ${
              hasActiveFilters
                ? "cursor-pointer border-[#E5E7EB] bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50"
                : "cursor-not-allowed border-[#E5E7EB] bg-white text-gray-400 opacity-50"
            }`}
            style={FILTER_BTN_RESET}
          >
            Clear all
          </button>
        </div>
      </div>

      {!loading ? (
        <p className="mb-0 mt-3 border-t border-[#E2E8F0] pt-3 text-[12px] leading-relaxed text-gray-500">
          <span className="font-semibold text-gray-800">{resultCount}</span>{" "}
          match{resultCount === 1 ? "" : "es"} ·{" "}
          <span className="font-semibold text-gray-800">{totalAwaiting}</span>{" "}
          awaiting on this tab
        </p>
      ) : null}
    </div>
  );
}

export default CommissionInstallmentsSearchFilters;
